import { CartonReturnService } from '../services/CartonReturnService';
import { CartonReturnConstants } from '../constants/CartonReturnConstants';
import { alertActions } from ".";

export const CartonReturnActions = {
    getAll,
    SaveReversePoint
};

function getAll(obj) {
    return dispatch => {
     
        dispatch(request()); // loading true
         
        CartonReturnService.fetchReverseData(obj)
            .then(response => {

                if (response.ResponseCode === "200") {

                    // API ResponseData → Table
                    dispatch(success(response.ResponseData));
                
                } else {
                    dispatch(failure(response.ResponseMessage));
                    dispatch(alertActions.error(response.ResponseMessage));
                }

            })
            .catch(error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };

    function request() {
        return { type: CartonReturnConstants.GETALL_REQUEST };
    }

    function success(datas) {
        return { type: CartonReturnConstants.GETALL_SUCCESS, datas };
    }

    function failure(error) {
        return { type: CartonReturnConstants.GETALL_FAILURE, error };
    }
}

function SaveReversePoint(requestObj) {
    return dispatch => {
        dispatch({ type: CartonReturnConstants.GETALL_REQUEST });

        return CartonReturnService.SaveReversePoint(requestObj)
            .then(response => {
                return response;    // return to component for toast handling
            })
            .catch(error => {
                dispatch(alertActions.error(error.toString()));
                return { ResponseCode: "500", ResponseMessage: error.toString() };
            });
    };
}